// extracted by mini-css-extract-plugin
export default {"container":"container-wiXsiUom","card":"card-HL37uj3G","title":"title-SCxT32Pm"};